/* eslint-disable kf/const-naming-convention */
import { useAccountStore } from "../../libs/stores";
// import { FLOW_TYPE } from "../../constants/metadata.constants";
import { FieldURLMapping } from "./url";
let accountId;

export function getAccountId() {
  if (!accountId) {
    accountId = useAccountStore.getState()._id;
  }
  return accountId;
}

export function getPublicUploadBaseUrl(flowType, flowId, instanceId) {
  return `/${flowType}/2/${getAccountId()}/publicform/${flowId}/${instanceId}/attachment`;
}

export function getPublicDownloadBaseUrl(flowType, flowId) {
  return `/${flowType}/2/${getAccountId()}/publicform/${flowId}/attachment/Download/`;
}

export const PublicFieldURLMapping = {
  Select: FieldURLMapping.Select,
  Multiselect: FieldURLMapping.Multiselect,
  Checkbox: FieldURLMapping.Checkbox,
  User: FieldURLMapping.User,
  UserAndGroup: FieldURLMapping.User,
  MultiUser: FieldURLMapping.MultiUser,
  Reference: FieldURLMapping.Reference,
  RemoteLookup: FieldURLMapping.RemoteLookup,
  JSON: FieldURLMapping.JSON,
  Image: FieldURLMapping.Image,
  Attachment: FieldURLMapping.Attachment,
  SmartAttachment: FieldURLMapping.SmartAttachment,
  Signature: FieldURLMapping.Signature,
  Text: FieldURLMapping.Text,
  XML: FieldURLMapping.XML
};
